import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
    Modal,ModalBody,ModalFooter, ModalHeader,
    Spinner
} from "reactstrap"

import moment from "moment"

import IndexBloc from "./Blocs/IndexBlock"

import Select from "react-select"

import TableActiveComponent from './Components/TableActiveComponent'

var reformatOptions = function(sources, label, value) {
  return sources.map(function(source) {
    var newObj = {};
    newObj["label"] = source[label];
    newObj["value"] = source[value];

    return newObj;
  });
};

const IndexView = (props) => {
  
    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")    
    const [fileUrl, setFileUrl] = useState("")    

    const activeRef = useRef();
    const inactiveRef = useRef();

    const [modal, setModal] = useState(false)

    // Select
    const [optionUnits, setOptionUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState("")
    const handleSelectUnit = (selectedUnit) => {
      setSelectedUnit(selectedUnit)
      setAdditionalFilter({
        ...additionalFilter,
        work_unit: selectedUnit.value || "",
      })
    }

    const [optionEmployeeStatus, setOptionEmployeeStatus] = useState([]);
    const [selectedEmployeeStatus, setSelectedEmployeeStatus] = useState("")
    const handleSelectEmployeeStatus = (selectedEmployeeStatus) => {
      setSelectedEmployeeStatus(selectedEmployeeStatus)
    }

    const [optionEchelon, setOptionEchelon] = useState([]);
    const [selectedEchelon, setSelectedEchelon] = useState("")
    const handleSelectEchelon = (sel) => {
        setSelectedEchelon(sel)
        setAdditionalFilter({
          ...additionalFilter,
          echelon: sel.value || "",
        })
    }

    const [additionalFilter, setAdditionalFilter] = useState({});

    useEffect( () => {
      // get data unit
      indexBloc.workUnitChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response.result
                      setOptionUnits(
                        reformatOptions(
                            response,
                            "work_unit_name_tabs",
                            "work_unit_uuid"
                        )
                      )
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      indexBloc.fetchWorkUnit({})

      indexBloc.echelonChannel.subscribe((result) => {
        switch (result.status) {
            case apiResponse.COMPLETED:
                if(result.data.status) {
                    let response = result.data.response.result
                    setOptionEchelon(
                      reformatOptions(
                        response,
                            "echelon_name",
                            "echelon_name"
                        )
                    )
                }
                break
            case apiResponse.ERROR:
                
                break
            default:
                break
        }
      })
      indexBloc.fetchEchelon({})

      return () => {
          console.log('unmount');
          indexBloc.workUnitChannel?.unsubscribe()
          indexBloc.echelonChannel?.unsubscribe()
      }
    }, [])

    const reloadActiveRef = () => activeRef.current.setTokenAPI()

    function handleButtonSearch() {
      reloadActiveRef()
    }

    function handleButtonReset() {
      setSelectedUnit('')
      setSelectedEmployeeStatus('')
      setSelectedEchelon('')
      setAdditionalFilter({})

      setTimeout(function() {
        reloadActiveRef()
      }, 100);
    }

    function handleButtonExport(){
        setModal(!modal)

        indexBloc.exportExcelChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response);
                        setFileUrl(response.file_url) 
                        //setModal(!modal)            
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        indexBloc.fetchExportExcel({
            ...additionalFilter
        })
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">New Sample</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>List Data Pegawai</CardTitle>
                                <CardSubtitle className="mb-3">
                                    {/* Daftar Urut Kepangkatan */}
                                </CardSubtitle>
                                <hr />

                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Unit Kerja
                                    </label>
                                    <Col md="6">
                                        <Select
                                            value={optionUnits.filter(option => 
                                              option.value === selectedUnit.value)}
                                            onChange={handleSelectUnit}
                                            required="required"
                                            options={optionUnits}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row>

                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Status Pegawai
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionEmployeeStatus.filter(option => 
                                              option.value === selectedEmployeeStatus.value)}
                                            onChange={handleSelectEmployeeStatus}
                                            required="required"
                                            options={optionEmployeeStatus}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row> */}

                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Eselon
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionEchelon?.filter(option => 
                                              option.value === selectedEchelon.value)}
                                            onChange={handleSelectEchelon}
                                            required="required"
                                            options={optionEchelon}
                                            classNamePrefix="select2-unitx"
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button>
                                        {' '}
                                        <Button 
                                          color="success" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonExport()
                                          }}>
                                            <i className="uil-file-download-alt"></i> Export
                                        </Button>
                                    </Col>
                                </Row>

                                <hr />
                                
                                <TableActiveComponent ref={activeRef} additionalFilter={additionalFilter}/>
                            </CardBody>
                        </Card>
                        
                       
                    </Col>
                </Row>
            </Container>

            <Modal
                isOpen={modal}
                role="dialog"
                autoFocus={true}
                centered={true}
                className="exampleModal"
                tabIndex="-1"
                toggle={() => {
                    setModal(!modal)
                }}
            >
                <div className="modal-content">
                <ModalHeader
                    toggle={() => {
                        setModal(!modal); setFileUrl("");
                    }}
                >
                    Export
                </ModalHeader>
                <ModalBody>
                    {
                        (fileUrl == "") ?
                            <div className="text-center">
                                <Spinner className="m-1" color="primary" />
                                <div>
                                    Memproses Data
                                </div>
                            </div> 
                            :
                            <>
                                <Row className='mb-3'>
                                    <label className="col-md-4">
                                        Jenis File
                                    </label>
                                    <Col md='8'>
                                        Excel (xlsx)
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <label className="col-md-4">
                                        Waktu Generate
                                    </label>
                                    <Col md='8'>
                                        {moment(new Date()).format("DD/MM/YYYY HH:mm")}
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <label className="col-md-4">
                                        Link
                                    </label>
                                    <Col md='8'>
                                        <a target={"_blank"} className="btn btn-success" href={fileUrl}>
                                            Download <i className="fa fa-download ms-1"></i>
                                        </a>
                                    </Col>
                                </Row>
                            </>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button
                        type="button"
                        color="secondary"
                        onClick={() => {
                            setModal(!modal); setFileUrl("");
                        }}
                    >
                    Kembali
                    </Button>
                </ModalFooter>
                </div>
            </Modal>

        </Fragment>
    )
}

export default IndexView